export type TToastVariant = "info" | "success" | "warning" | "error";

export type TToastPosition =
    | "top-left"
    | "top-left-corner"
    | "top-center"
    | "top-right"
    | "top-right-corner"
    | "bottom-left"
    | "bottom-left-corner"
    | "bottom-center"
    | "bottom-right"
    | "bottom-right-corner";

export interface IToast {
    id: string;
    variant: TToastVariant;
    title?: string;
    description?: string;
    durationMs?: number;
}

export interface IToastConfig {
    position: TToastPosition;
    durationMs: number;
    maxVisible: number;
}

export interface IToastEntity extends IToast {
    createdAt: number;
    durationMs: number;
}

export const DEFAULT_TOAST_CONFIG: IToastConfig = {
    position: "bottom-center",
    durationMs: 1000,
    maxVisible: 3,
};
